import React from "react";
import Particles from "react-particles-js";
import styled from "styled-components";
import { useTheme } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";
import getDots from "../Page/getDots";
import Transition from "../../components/Transition";

const StyledDot = styled(Particles)`
  & canvas {
    position: fixed;
    right: 0;
    left: 0;
    bottom: 1.25rem;
    z-index: 0;
  }
`;

export default function StyleDots() {
  const theme = useTheme();
  const params = getDots(theme);

  return (
    <Transition in component={Fade}>
      <div>
        <StyledDot params={params} />
      </div>
    </Transition>
  );
}
